import React from "react";

import { currenciesData } from "../../data/data.ts";
import { setCurrency } from "./currencyFilterSlice.ts";

export const CurrencyFilter = ({ currencyFilter, dispatch }) => {
  const onClickHandler = (currency) => {
    dispatch(setCurrency(currency));
  };

  return (
    <div id="currency-filters-container" aria-label="Select display currency">
      <h3>Currency</h3>
      {currenciesData.map(createCurrencyButton)}
    </div>
  );

  function createCurrencyButton(currency) {
    const isSelected = currencyFilter === currency;

    return (
      <button
        type="button"
        className={`currency-button ${isSelected ? "selected" : ""}`}
        key={currency}
        onClick={() => onClickHandler(currency)}
        aria-pressed={isSelected}
      >
        {currency}
      </button>
    );
  }
};
